import { useIntl } from 'react-intl'
import { SidebarMenuItem } from '../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem'
import { SidebarMenuItemWithSub } from '../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub'
import { FeatureType } from '../config/featureConfig'
import { useFeature } from './featureFlagEngine'
import { useAuthStore } from '../store/authStore'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const org = useAuthStore((state) => state.orgName)

  const { childrenPermission, sidebarPermission } = useFeature()
  // Get all sidebar items from feature flag engine
  const sidebarItems = sidebarPermission()
  return (
    <div className='d-flex flex-column justify-content-between h-100'
      style={{ overflow: "auto" }}

    >

      <div>
        {sidebarItems.map((feature) => {
          // Special handling for Dashboard - show org name if available
          const title = (feature.id === 'dashboard' && org)
            ? org
            : intl.formatMessage({ id: feature.name })

          // Menu groups or parents with children
          if (
            feature.type === FeatureType.MENU_GROUP ||
            (feature.type === FeatureType.PARENT && feature.children?.length)
          ) {
            const children = childrenPermission(feature.id)

            // Only show menu if it has visible children in sidebar
            const visibleChildren = children.filter((child) => child.sidebar?.show)

            if (visibleChildren.length === 0 && feature.type === FeatureType.MENU_GROUP) {
              // Menu groups with no visible children shouldn't show
              return null
            }

            return (
              <SidebarMenuItemWithSub
                key={feature.id}
                to={feature.route || '#'}
                title={title}
                icon={feature.sidebar?.icon}
                dataTour={feature.id === 'workflow' ? 'sidebar-workflow' : undefined}
              >
                {(visibleChildren).map((child) => {
                  return (
                    <SidebarMenuItem
                      key={child.id}
                      to={child.route!}
                      title={intl.formatMessage({ id: child.name })}
                      icon={child.sidebar?.icon}
                    />
                  )
                })}
              </SidebarMenuItemWithSub>
            )
          }

          // Standalone items
          return (
            <SidebarMenuItem
              key={feature.id}
              to={feature.route!}
              title={title}
              icon={feature.sidebar?.icon}
              dataTour={feature.id === 'workflow' ? 'sidebar-workflow' : undefined}
            />
          )
        })}
      </div>
    </div>
  )
}

export { SidebarMenuMain }
